(function() {
  'use strict';

  angular.module('ringbaPortal').directive('trLoader', trLoader);

  function trLoader() {
    const directive = {
      restrict: 'E',
      scope: {
        items: '<',
        loading: '<',
        loaderId: '@',
        loadingText: '@',
        noItemText: '@'
      },
      controller: LoaderController,
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: '/scripts/shared/directives/loader/loader.view.html'
    };
    return directive;
  }

  function LoaderController(
    bsLoadingOverlayService
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;

    function onInit() {
      if (vm.loaderId) {
        bsLoadingOverlayService.start({
          referenceId: vm.loaderId
        });
      }
    }
  }
})();
